
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CreditCard, Users, Database, Mail } from 'lucide-react'; // Replaced Marketing with Mail
import PaymentIntegrationsTab from './PaymentIntegrationsTab';
import CRMIntegrations from './integrations/CRMIntegrations';
import DataChannelIntegrations from './integrations/DataChannelIntegrations';
import EmailMarketingIntegrations from './integrations/EmailMarketingIntegrations';

interface IntegrationsSettingsTabProps {
  onSaved: () => Promise<void>;
  initialEcommerceData?: {
    shopifyConnected?: boolean;
    woocCommerceConnected?: boolean;
    bigCommerceConnected?: boolean;
  };
  activeTab?: string;
}

const IntegrationsSettingsTab: React.FC<IntegrationsSettingsTabProps> = ({ 
  onSaved, 
  initialEcommerceData = {},
  activeTab = 'payments'
}) => {
  const [currentTab, setCurrentTab] = useState(activeTab);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Integrations</CardTitle>
        <CardDescription>
          Configure third-party integrations for your business
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs value={currentTab} onValueChange={setCurrentTab} className="w-full">
          <TabsList className="mb-4 grid w-full max-w-md grid-cols-4">
            <TabsTrigger value="payments" className="flex items-center">
              <CreditCard className="mr-2 h-4 w-4" />
              <span>Payments</span>
            </TabsTrigger>
            <TabsTrigger value="crm" className="flex items-center">
              <Users className="mr-2 h-4 w-4" />
              <span>CRM</span>
            </TabsTrigger>
            <TabsTrigger value="data-channels" className="flex items-center">
              <Database className="mr-2 h-4 w-4" />
              <span>Data Channels</span>
            </TabsTrigger>
            <TabsTrigger value="email-marketing" className="flex items-center">
              <Mail className="mr-2 h-4 w-4" />
              <span>Email Marketing</span>
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="payments">
            <PaymentIntegrationsTab onSaved={onSaved} />
          </TabsContent>
          
          <TabsContent value="crm">
            <CRMIntegrations onSaved={onSaved} />
          </TabsContent>
          
          <TabsContent value="data-channels">
            <DataChannelIntegrations onSaved={onSaved} />
          </TabsContent>
          
          <TabsContent value="email-marketing">
            <EmailMarketingIntegrations onSaved={onSaved} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default IntegrationsSettingsTab;

